import { get } from 'lodash';
import React from 'react';
import { OriSelect } from 'src/components/Antd';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Option = OriSelect.Option;
const Animation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, animations, hoverAnimations } = props;
  const _animations = [
    { value: null, label: getI18n('general.status.none') },
    ...(animations || []).map((i) => {
      const { name, uuid } = i;
      return { label: name, value: uuid };
    }),
  ];
  const _hoverAnimations = [
    { value: null, label: getI18n('general.status.none') },
    ...(hoverAnimations || []).map((i) => {
      const { name, uuid } = i;
      return { label: name, value: uuid };
    }),
  ];
  //console.log('_hoverAnimations', _hoverAnimations);
  const entranceUuid = get(data, 'entranceUuid') || null;
  const hoverEffectUuid = get(data, 'hoverEffectUuid') || null;
  //console.log('hoverEffectUuid', hoverEffectUuid);
  return (
    <React.Fragment>
      <ItemWrapper size='small' title={getI18n('general.entranceAnimation')}>
        <OriSelect
          size='large'
          value={entranceUuid}
          onChange={(entranceUuid) => {
            onChange({ entranceUuid });
          }}>
          {_animations.map((i) => {
            const { label, value } = i;
            return (
              <Option
                value={value}
                key={value || getI18n('general.status.none')}>
                {label}
              </Option>
            );
          })}
        </OriSelect>
      </ItemWrapper>
      <ItemWrapper size='small' title={getI18n('general.hoverEffect')}>
        <OriSelect
          size='large'
          value={hoverEffectUuid}
          onChange={(hoverEffectUuid) => {
            onChange({ hoverEffectUuid });
          }}>
          {_hoverAnimations.map((i) => {
            const { label, value } = i;
            return (
              <Option
                value={value}
                key={value || getI18n('general.status.none')}>
                {label}
              </Option>
            );
          })}
        </OriSelect>
      </ItemWrapper>
    </React.Fragment>
  );
};
export default Animation;
